export default __webpack_public_path__ + "static/media/tabler-icon-warning.9619a09e.svg";